module.exports = __webpack_public_path__ + "static/media/kyushu-img.aee93c20.png";